// SectionCard — flat rich-detail section surface (12px --r-4 radius, no shadow)
// with a standard header: eyebrow title + optional count + optional action slot.
// Deliberately flatter than the shadowed `Card` atom (LayoutAtoms). i18n-clean:
// title, count, action, and children arrive via props; imports only from `./`.
import type { CSSProperties, ReactNode } from 'react';

export interface SectionCardProps {
  title: ReactNode;
  count?: number;
  action?: ReactNode;
  children: ReactNode;
  as?: 'section' | 'div'; // default 'section'
}

export function SectionCard({ title, count, action, children, as }: SectionCardProps) {
  const Tag: 'section' | 'div' = as ?? 'section';

  const surface: CSSProperties = {
    background: 'var(--bg-1)',
    border: '1px solid var(--border-1)',
    borderRadius: 'var(--r-4)',
  };

  return (
    <Tag style={surface}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: 'var(--s-4) var(--s-5)',
        }}
      >
        <h2 className="eyebrow" style={{ margin: 0 }}>
          {title}
        </h2>
        {count !== undefined && (
          <span style={{ color: 'var(--fg-4)', fontSize: 'var(--fz-13)' }}>{count}</span>
        )}
        <span style={{ flex: 1 }} />
        {action}
      </div>
      <div style={{ padding: 'var(--s-5)' }}>{children}</div>
    </Tag>
  );
}
